import { phoneNumberDefault } from '../../../constants/voip-settings';
export const getValidatedPhoneNumber = (phoneNumber) => {
    if (!phoneNumber)
        return phoneNumberDefault;
    const regExp = /^[0-9]{5,10}$/g;
    return regExp.test(phoneNumber) ? phoneNumber : phoneNumberDefault;
};
